<template>
  <div>
    <div class="overflow-hidden rounded-sm bg-white shadow-md w-11/12 lg:w-4/12 m-auto mb-10">
      <div class="p-5 pt-8 text-white bg-header">
        <header>
          <h1 class="text-4xl font-bold">{{pageContent.title}}</h1>
          <h2 class="font-bold">{{ pageContent.subtitle }}</h2>
        </header>
      </div>
      <div class="p-5 py-7">
        <h3 class="text-xl text-gray-600">Enter your new password.</h3>

        <!-- server message -->
        <p class="my-2 animate__animated " :class="serverMessage.err ? ['text-pink-500 animate__headShake'] : ['animate__rubberBand text-green-500'] " v-if="serverMessage.val" v-html="serverMessage.val"></p>

        <div class="text-left mb-2 mt-4" >
          <p><b>NOTE</b>: Password is required to meet the following rules: <br /></p>
          <ul class="list-disc ml-8">
            <li :class="{ 'password-met' : password.rules.includes('M') }">minimum of 6 characters long</li>
            <li :class="{ 'password-met' : password.rules.includes('U') }">at least one upper case letters</li>
            <li :class="{ 'password-met' : password.rules.includes('L') }">at least one lower case letters</li>
            <li :class="{ 'password-met' : password.rules.includes('D') }">at least one number</li>
            <li :class="{ 'password-met' : password.rules.includes('S') }">at least one special character</li>
          </ul>
        </div>
        <main>
          <form @submit.prevent="submitForm">

            <!-- password -->
            <div class="flex items-center justify-start rounded-md border p-2 mt-2 mb-1 border-gray-500">
              <label :for="password.name" class="mr-2 text-gray-500">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M12,2C9.243,2,7,4.243,7,7v3H6c-1.103,0-2,0.897-2,2v8c0,1.103,0.897,2,2,2h12c1.103,0,2-0.897,2-2v-8c0-1.103-0.897-2-2-2 h-1V7C17,4.243,14.757,2,12,2z M18,12l0.002,8H6v-8H18z M9,10V7c0-1.654,1.346-3,3-3s3,1.346,3,3v3H9z"></path></svg>
              </label>
              <input class="flex-auto placeholder-gray-500 focus:placeholder-gray-300" @keyup="validatePassword" :type="password.show ? 'text':'password'" :name="password.name"  :placeholder="password.name" v-model.trim="password.val">
              <button type="button" class="mr-1" @click="password.show = !password.show">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" v-if="password.show">
                  <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                  <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" v-else>
                  <path fill-rule="evenodd" d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z" clip-rule="evenodd" />
                  <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
                </svg>
              </button>
            </div>
            <p class="animate__animated animate__headShake text-left text-pink-500" v-if="password.err">{{password.err}}</p>

            <!-- confirm password -->
            <div class="flex items-center justify-start rounded-md border p-2 mt-2 mb-1 border-gray-500">
              <label :for="confirmPassword.name" class="mr-2 text-gray-500">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M12,2C9.243,2,7,4.243,7,7v3H6c-1.103,0-2,0.897-2,2v8c0,1.103,0.897,2,2,2h12c1.103,0,2-0.897,2-2v-8c0-1.103-0.897-2-2-2 h-1V7C17,4.243,14.757,2,12,2z M18,12l0.002,8H6v-8H18z M9,10V7c0-1.654,1.346-3,3-3s3,1.346,3,3v3H9z"></path></svg>
              </label>
              <input class="flex-auto placeholder-gray-500 focus:placeholder-gray-300" :type="confirmPassword.show ? 'text':'password'" :name="confirmPassword.name"  :placeholder="confirmPassword.name" v-model.trim="confirmPassword.val">
              <button type="button" class="mr-1" @click="confirmPassword.show = !confirmPassword.show">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" v-if="confirmPassword.show">
                  <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                  <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" v-else>
                  <path fill-rule="evenodd" d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z" clip-rule="evenodd" />
                  <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
                </svg>
              </button>
            </div>
            <p class="animate__animated animate__headShake text-left text-pink-500" v-if="confirmPassword.err">{{confirmPassword.err}}</p>

            <button type="submit" class="overflow-hidden w-full bg-blue-500 hover:bg-blue-600 text-white font-bold rounded-md p-2 mt-2 mb-1">Submit</button>

          </form>
        </main>
      </div>
      <div class="p-5">
        <footer>
          <h2 class="text-sm" v-html="pageContent.copyright"></h2>
        </footer>
      </div>
    </div>    
  </div>
</template>

<script>
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { ref, computed, onMounted } from 'vue';

export default {
  name: "Reset Password",
  setup() {
    
    // vuex store
    const store = useStore();

    // vue-router
    const route = useRoute();

    const pageContent = computed(() => store.getters.pageContent );

    // REGEX
    const REGEX = {
       PASSWORD_U: /^(?=.*[A-Z]).{0,}$/ // eslint-disable-line
      ,PASSWORD_L: /^(?=.*[a-z]).{0,}$/ // eslint-disable-line
      ,PASSWORD_D: /^(?=.*[0-9]).{0,}$/ // eslint-disable-line
      ,PASSWORD_S: /^(?=.*[!@#?]).{0,}$/ // eslint-disable-line
    }

    // onMounted
    onMounted(async () => {
      clearServerMessage();
      if(!resetToken.value.val){
        serverMessage.value.val = "Reset token is required."
        serverMessage.value.err = true;
      } else {
        try {
          await store.dispatch("authModule/checkResetTokenValidty", { resetToken : resetToken.value.val } )
        } catch (error) {
          serverMessage.value.val = error.msg;
          serverMessage.value.err = true;
        }
      }
    });

    // form
      const resetToken = ref({
        val: route.query.token,
        err: false,
      });

      const serverMessage = ref({
        val:"",
        err: false,
      })

      const password = ref({
        name:"Password",
        val:"",
        err:"",
        rules: [],
        show: false
      });      
      const confirmPassword = ref({
        name:"Confirm Password",
        val:"",
        err:"",
        show: false
      });
      
      function clearForm(){
        password.value.val = "";
        confirmPassword.value.val = "";
        serverMessage.value.val = "";

        password.value.err = "";
        password.value.rules = [];
        confirmPassword.value.err = "";
        serverMessage.value.err = false;
      }

      async function submitForm(){
        const isReset = await resetError(); 
        if(isReset){
          const isValidated = await validateForm();
          if(isValidated){
            const form = {
              resetToken: resetToken.value.val,
              password : password.value.val,
              confirmPassword : confirmPassword.value.val,
            }
            try {
              const data = await store.dispatch("authModule/resetPasswordForm", form);
              clearForm();
              serverMessage.value.val = data.message;
                setTimeout(() => {
                  clearServerMessage();
              }, 5000);

            } catch (error) {

              if(error.msg){
                serverMessage.value.val = error.msg;
                serverMessage.value.err = true;
                setTimeout(() => {
                  clearServerMessage();
                }, 3000);
              } 

              if(error.errors){
                error.errors.forEach(element => {
                 this[element.param].err = element.msg;

                 if(element.param === 'resetToken'){
                    serverMessage.value.val = element.msg;
                    serverMessage.value.err = true;
                 }
                });
              }
            }
          }
        }
      }

      function clearServerMessage(){
        serverMessage.value.val = "";
        serverMessage.value.err = false;
      }

      function resetError(){
        return new Promise((resolve)=>{
          password.value.err = "";
          password.value.rules = [];
          confirmPassword.value.err = "";
          resolve(true);
        })  
      }

      function validatePassword(){

        // password 
        password.value.rules = [];       
        if(password.value.val.length !== 0 && password.value.val.length >= 6){
          password.value.rules.push("M")
        }          
        if(REGEX.PASSWORD_U.test(password.value.val)){
          password.value.rules.push("U")
        }
        if(REGEX.PASSWORD_L.test(password.value.val)){
          password.value.rules.push("L")
        }
        if(REGEX.PASSWORD_D.test(password.value.val)){
          password.value.rules.push("D")
        }
        if(REGEX.PASSWORD_S.test(password.value.val)){
          password.value.rules.push("S")
        }

      }

       function validateForm(){
        return new Promise((resolve)=>{

          const requireStr = " is required.";

          // password
          if(!password.value.val){
            password.value.err =  password.value.name + requireStr;
          }else {
            
            if(password.value.val.length >= 6){
              password.value.rules.push("M")
            }          
            if(REGEX.PASSWORD_U.test(password.value.val)){
              password.value.rules.push("U")
            }
            if(REGEX.PASSWORD_L.test(password.value.val)){
              password.value.rules.push("L")
            }
            if(REGEX.PASSWORD_D.test(password.value.val)){
              password.value.rules.push("D")
            }
            if(REGEX.PASSWORD_S.test(password.value.val)){
              password.value.rules.push("S")
            }
            
            if(password.value.rules.length != 5){
              password.value.err = password.value.name + " must meet the rules stated.";
            }

          }

          // confirm password
          if(!confirmPassword.value.val){
            confirmPassword.value.err =  confirmPassword.value.name + requireStr;
          }else if(confirmPassword.value.val != password.value.val && password.value.val){
            confirmPassword.value.err = "Password do not match."
          }

          resolve(!password.value.err && !confirmPassword.value.err);

        })  
      }

    return{
      pageContent,
      serverMessage, password, confirmPassword, resetToken,
      submitForm, clearForm, validatePassword
    }
  }
}
</script>

<style lang="scss">
.password-met::after{
  content: "✔";
  @apply text-green-500 ml-2;
}
</style>
